import { Injectable } from '@angular/core';
import { WrapperStandardRequest, WrapperStandardResponse } from '../../common/models/wrapper.model';
import { BaseService } from './base-service';

@Injectable({
    providedIn: 'root'
})
export abstract class GenericService<T> extends BaseService<T>{
    /*
    override  getAll(aUrl: string, aRequestData: any): any {
        return 'Manoj from generic service';
         super.getAll(aUrl, aRequestData).subscribe((wrapperStandardResponse: WrapperStandardResponse<Array<T>>) => {
            console.log( 'generic ' + wrapperStandardResponse);
            
            return wrapperStandardResponse.ResponseData;
        })

    }

*/

    override PostAPIWithWrapperAndT(aUrl: string, aRequestData: any): any {
        let promise = new Promise((resolve, reject) => {
            super.PostAPIWithWrapperAndT(aUrl, aRequestData).subscribe((wrapperStandardResponse: WrapperStandardResponse<Array<T>>) => {
                resolve(wrapperStandardResponse.responseData)
            })
        });
        return promise;
    }

    PostAPIWithWrapperRequestT(aUrl: string, aRequestData: T): any {

        const wrapperStandardRequest: WrapperStandardRequest<any> = new WrapperStandardRequest<any>();

        wrapperStandardRequest.RequestData = aRequestData;

        let promise = new Promise((resolve, reject) => {
            super.PostAPI(aUrl, wrapperStandardRequest).subscribe((wrapperStandardResponse: WrapperStandardResponse<T>) => {
                resolve(wrapperStandardResponse.responseData)
            })
        });
        return promise;
    }

    PostAPIWithWrapperReturnsT(aUrl: string, aRequestData: any): any {

        const wrapperStandardRequest: WrapperStandardRequest<any> = new WrapperStandardRequest<any>();

        wrapperStandardRequest.RequestData = aRequestData;

        let promise = new Promise((resolve, reject) => {
            super.PostAPI(aUrl, wrapperStandardRequest).subscribe(async (wrapperStandardResponse: WrapperStandardResponse<T>) => {
                resolve(await wrapperStandardResponse)
            })
        });
        return promise;
    }
    

    PostAPIWithWrapperReturnsArrayOfT(aUrl: string, aRequestData: any): any {

        const wrapperStandardRequest: WrapperStandardRequest<any> = new WrapperStandardRequest<any>();

        wrapperStandardRequest.RequestData = aRequestData;

        let promise = new Promise((resolve, reject) => {
            super.PostAPI(aUrl, wrapperStandardRequest).subscribe((wrapperStandardResponse: WrapperStandardResponse<Array<T>>) => {
                resolve(wrapperStandardResponse.responseData)
            })
        });
        return promise;
    }

    PostAPIWithWrapperRequestAndReturnsArrayOfT(aUrl: string, aRequestData: WrapperStandardRequest<any>): any {

        //const wrapperStandardRequest: WrapperStandardRequest<any> = new WrapperStandardRequest<any>();

        //wrapperStandardRequest.RequestData = aRequestData;

        let promise = new Promise((resolve, reject) => {
             super.PostAPI(aUrl, aRequestData).subscribe( async (wrapperStandardResponse: WrapperStandardResponse<Array<T>>) => {
                resolve(await wrapperStandardResponse)
            })
        });
        return promise;
    }

    PostAPIForSAP(aUrl: string, aRequestData: any): any {
        //const dto = mapper.map(aRequestData, T, BranchMasterModelSAP);
        let promise = new Promise((resolve, reject) => {
            this.PostAPI(aUrl, aRequestData).subscribe((responseData: any) => {
                resolve(responseData)
            })
        });
        return promise;
    }

    PatchAPIForSAP(aUrl: string, aRequestData: any): any {
        let promise = new Promise((resolve, reject) => {
            this.PatchAPI(aUrl, aRequestData).subscribe((responseData: any) => {
                resolve(responseData)
            })
        });
        return promise;
    }


    //Scroll Pagination
    PostAPIWithOnScrollPaginationWrapperRequestAndReturnsArrayOfT(aUrl: string, aRequestData: WrapperStandardRequest<any>): any {
        //const wrapperStandardRequest: WrapperStandardRequest<any> = new WrapperStandardRequest<any>();
        //wrapperStandardRequest.RequestData = aRequestData;
        let promise = new Promise((resolve, reject) => {
            super.PostAPI(aUrl, aRequestData).subscribe((wrapperStandardResponse: WrapperStandardResponse<T>) => {
                resolve(wrapperStandardResponse)
            })
        });
        return promise;
    }

    PostAPIWithOnScrollPaginationWrapperRequestArray(aUrl: string, aRequestData: WrapperStandardRequest<any>): any {
        let promise = new Promise((resolve, reject) => {
            super.PostAPI(aUrl, aRequestData).subscribe((wrapperStandardResponse: WrapperStandardResponse<T>) => {
                resolve(wrapperStandardResponse)
            })
        });
        return promise;
    }
     PostApiForSaveDocument(aUrl: string, aRequestData: any): any {
        let promise = new Promise((resolve, reject) => {
            super.PostAPI(aUrl, aRequestData).subscribe((wrapperStandardResponse: WrapperStandardResponse<T>) => {
                resolve(wrapperStandardResponse)
            })
        });
        return promise;
    }

    GetAPIForSAP(aUrl: string): any {
        let promise = new Promise((resolve, reject) => {
            this.GetAPI(aUrl).subscribe((responseData: any) => {
                resolve(responseData)
            })
        });
        return promise;
    }
}